import React, { FC } from 'react';
import AgentLeadTable from '~/components/views/agent/AgentLeadTable';

const Agent: FC = () => {
  return <AgentLeadTable />;
};

export default Agent;
